import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';

@Pipe({
  name: 'promo-date-pipe'
})

export class DateRangePipe implements PipeTransform {
  transform(obj: any, args?: any): any {

  const datePipe = new DatePipe('en-US');
  let start = datePipe.transform(obj.startDate, 'dd/MM/yy');
  let end = datePipe.transform(obj.endDate, 'dd/MM/yy');
  let str = '<span>' + start + '</span>' + '<br>' +  '<span>' + end + '</span>'
  return str;
  }
}
